import React, { useEffect, useState } from 'react';
import { useDataProvider, useNotify } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import DataDistributionCard from '../../../Components/DataDistributionCard';
import { formatEnCaRange } from '../../../utils';
import Spinner from '../../../Components/Spinner';
import NoData from './NoData';

const AllResponses = ({ showLegend, range, serviceType }) => {
    const dataProvider = useDataProvider()
    const notify = useNotify()

    const [allQuestionsBreakdown, setAllQuestionsBreakdown] = useState(null)
    const [statsFetched, setStatsFetched] = useState(false)

    useEffect(()=> {
        setStatsFetched(false)
        fetchAllQuestionsBreakdown()
    },[range, serviceType])


    const fetchAllQuestionsBreakdown = () => {
        const queryStringParams = formatEnCaRange(range)
        queryStringParams.service_type_id = serviceType

        dataProvider('GET_LIST', 'elevation/questions/breakdown/all', { queryStringParams })
            .then(res => {
                setAllQuestionsBreakdown(res.data)
                setStatsFetched(true)
            })
            .catch((e) => {
                notify(e.message, 'warning')
            })
    }

    if (!statsFetched) {
        return <Spinner />
    }

    if (allQuestionsBreakdown && allQuestionsBreakdown.length !== 0) {
        return (
            <Grid container spacing={3}>
                {allQuestionsBreakdown.map((question) =>
                    <DataDistributionCard
                        key={`all-responses-card-question-${question.question_id}`}
                        title={question.label_template}
                        subheader={question.review_count === undefined ? '' : `${question.review_count} ${question.review_count === 1 ? "review" : "reviews"}`}
                        dataDistributionSections={question.answers.filter(answer => answer.response_count && answer.score !== null)}
                        isPositiveMetric={undefined}
                        showLegend={showLegend}
                        rankingLocked={false}
                        helpdocLink={question.helpdoc_link}
                        insightsDrawerButtonLink={`/elevation-client-answers/v2?service_type_id=${serviceType}&to=${range.to.toLocaleDateString('en-CA')}&from=${range.from.toLocaleDateString('en-CA')}`}
                    />
                )}
            </Grid>
        )
    }

    return <NoData statName="All responses" />
}

export default AllResponses